var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.0352C0 31.0809 8.95431 40.0352 20 40.0352C31.0457 40.0352 40 31.0809 40 20.0352C40 8.98946 31.0457 0.0351562 20 0.0351562C8.95431 0.0351562 0 8.98946 0 20.0352Z",
    fill: "#550080",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.7852C29.25 14.1602 28.5 14.2852 27.625 14.4102C28.5 13.9102 29.125 13.1602 29.375 12.1602C28.625 12.6602 27.75 12.9102 26.75 13.1602C26 12.4102 24.875 11.9102 23.75 11.9102C21.125 11.9102 19.125 14.4102 19.75 16.9102C16.375 16.7852 13.375 15.1602 11.25 12.6602C10.125 14.5352 10.75 16.9102 12.5 18.1602C11.875 18.1602 11.25 17.9102 10.625 17.6602C10.625 19.5352 12 21.2852 13.875 21.7852C13.25 21.9102 12.625 22.0352 12 21.9102C12.5 23.5352 14 24.7852 15.875 24.7852C14.375 25.9102 12.125 26.5352 10 26.2852C11.875 27.4102 14 28.1602 16.25 28.1602C23.875 28.1602 28.125 21.7852 27.875 15.9102C28.75 15.4102 29.5 14.6602 30 13.7852Z",
    fill: "#550080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/Tw.5e0bafa20a6b882ad9f5ed47ba9c5253.svg";
export { ForwardRef as ReactComponent };